import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { FunctionSquareIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const fridaDefinition: SmartSignalDefinition<{ frida?: IdEventV4['frida'] }> = {
  key: 'frida',
  label: 'Frida',
  extract: (e) => ({ frida: e.frida }),
  icon(e) {
    const p = this.extract(e)?.frida
    return (
      <FunctionSquareIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.frida
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"frida":',
  documentationHash: '#frida-detection',
  urlParamKey: IdentificationUrlKeys.Frida,
}
